import React, { useState, useEffect } from 'react';
import {  useNavigate, useLocation } from 'react-router-dom';
import Logo from '../Images/logo1.png';
import { MdDashboard} from 'react-icons/md';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa';
import { IoPower } from 'react-icons/io5';
import '../css/Adminpanel/Sidebar.css';
import { MdBuild } from 'react-icons/md';
import { RiPagesLine } from "react-icons/ri";
import { IoSettingsSharp } from "react-icons/io5";
import { MdAddPhotoAlternate } from "react-icons/md";
import { HiLocationMarker } from "react-icons/hi";
import { MdCleaningServices } from "react-icons/md";
import { IoPeopleSharp } from "react-icons/io5";
import { MdOutlinePersonPin } from "react-icons/md";
import { FaRegFileArchive } from "react-icons/fa";
import { FaFilePen } from "react-icons/fa6";
import { GrUserManager } from "react-icons/gr";
import { BsPersonBadge } from "react-icons/bs";
import { MdOutlineSettingsApplications } from "react-icons/md";
import { MdFindInPage } from "react-icons/md";
import { TbReportSearch } from "react-icons/tb";
import { FaAddressBook } from "react-icons/fa";
import { LiaPagerSolid } from "react-icons/lia";
import { GrTask } from "react-icons/gr";
import { VscTasklist } from "react-icons/vsc";
import { LuFilePen } from "react-icons/lu";
import { SiQuicktime } from "react-icons/si";
import { MdOutlineQuickreply } from "react-icons/md";
import { HiDocumentCurrencyRupee } from "react-icons/hi2";
import { BsWalletFill } from "react-icons/bs";
import { TbReportMoney } from "react-icons/tb";
import { MdManageSearch } from "react-icons/md";
import { BiLogOut } from "react-icons/bi";
import { MdAccessTime } from "react-icons/md";
import socket from "./socket";

const AdminSidebar = () => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const [showLogout, setShowLogout] = useState(false);
  const toggleSidebar = () => {
    setCollapsed(!collapsed);
    if (!collapsed) {
      setDashboardOpen(false);
      setServicesOpen(false);
    }
  };
  const [quickNotification, setQuickNotification] = useState(false);
  const [planNotification, setPlanNotification] = useState(false);

  useEffect(() => {
    socket.on("newService", () => {
      setQuickNotification(true);
      setQuickOpen(true);
    });
    socket.on("newPlan", () => {
      setPlanNotification(true);
      setPlanOpen(true);
    });
    return () => {
      socket.off("newService");
      socket.off("newPlan");
    };
  }, []);
  
  const [dashboardOpen, setDashboardOpen] = useState(location.pathname.startsWith('/admin/admin-dashboard') || location.pathname.startsWith('/admin/setting') || location.pathname.startsWith('/admin/banner') || location.pathname.startsWith('/admin/pincode-master'));
  const [servicesOpen, setServicesOpen] = useState(location.pathname.startsWith('/admin/manage-service'));
  const [usersOpen, setUserOpen] = useState(location.pathname.startsWith('/admin/user-list'));
  const [plansOpen, setPlanOpen] = useState(location.pathname.startsWith('/admin/subscription-plan') || location.pathname.startsWith('/admin/subscription-history') || location.pathname.startsWith('/admin/subscription-report') || location.pathname.startsWith('/admin/custom-plan'));
  const [staffOpen, setStaffOpen] = useState(location.pathname.startsWith('/admin/staff') || location.pathname.startsWith('/admin/daily-attendence') || location.pathname.startsWith('/admin/monthly-attendence') || location.pathname.startsWith('/admin/payroll') || location.pathname.startsWith('/admin/staff-withdrawal'));
  const [settingOpen, setSettingOpen] = useState(location.pathname.startsWith('/admin/setting'));
  const [taskOpen, setTaskOpen] = useState(location.pathname.startsWith('/admin/task') || location.pathname.startsWith('/admin/task-report'));
  const [quickOpen, setQuickOpen] = useState(location.pathname.startsWith('/admin/quick-history') || location.pathname.startsWith('/admin/quick-pending'));
  const handleLogout = () => {
    localStorage.removeItem('isAdmin');
    navigate('/admin-login');
    window.location.reload();
  };
  return <>
      <div className={`sidebar-area ${collapsed ? "" : "collapsed"}`}>

        <div className='d-flex justify-content-between'>
          <img src={Logo} className='sidebar-logo p-1' alt='Logo Sidebar' />
          <div className='align-content-center'>
            <span className="sidebar-item py-2 px-3" onClick={toggleSidebar}>
              {collapsed ? <FaAngleLeft size={22} /> : <FaAngleRight size={22} />}
            </span></div>

        </div>
      

        <div className='mt-4'>
          <p className='sidebar-menu-title'>MENU</p>

          {/* Dashboard Section */}
          <ul className='list-unstyled ps-0'>
            <li className='sidebar-item' onClick={() => setDashboardOpen(!dashboardOpen)}>
              <MdDashboard size={22} />
              <span className='sidebar-text'>Dashboard</span>
            </li>


            {dashboardOpen && <ul className='sidebar-submenu'>
                <li className={`sidebar-item ${location.pathname === '/admin/admin-dashboard' ? 'active' : ''}`} onClick={() => {
              navigate('/admin/admin-dashboard');
              setCollapsed(false);
              setDashboardOpen(false);
            }}>
                  {!collapsed && <RiPagesLine size={22} />}
                  <span className='sidebar-text'>Overview</span>
                </li>

               
              </ul>}
          </ul>

          {/* Services Section */}
          <p className='sidebar-menu-title mt-4'>SERVICES</p>
          <ul className='list-unstyled ps-0'>
            <li className='sidebar-item' onClick={() => setServicesOpen(!servicesOpen)}>
              <MdBuild size={22} />
              <span className='sidebar-text'>Services</span>
            </li>

            {servicesOpen && <ul className='sidebar-submenu'>
                <li className={`sidebar-item ${location.pathname === '/admin/manage-service' ? 'active' : ''}`} onClick={() => {
              navigate('/admin/manage-service');
              setCollapsed(false);
              setServicesOpen(false);
            }}>

                     {!collapsed && <MdCleaningServices size={22} />}
                                    <span className='sidebar-text'>Manage Service</span>
                 
                </li>

                  
               
              </ul>}
          </ul>



               <p className='sidebar-menu-title mt-4'>Users</p>
               <ul className='list-unstyled ps-0'>
            <li className='sidebar-item' onClick={() => setUserOpen(!usersOpen)}>
              <IoPeopleSharp size={22} />
              <span className='sidebar-text'>Users</span>
            </li>

            {usersOpen && <ul className='sidebar-submenu'>
                <li className={`sidebar-item ${location.pathname === '/admin/user-list' ? 'active' : ''}`} onClick={() => {
              navigate('/admin/user-list');
              setCollapsed(false);
              setServicesOpen(false);
            }}>

                     {!collapsed && <MdOutlinePersonPin size={22} />}
                                    <span className='sidebar-text'>Manage Users</span>
                 
                </li>
               
              </ul>}
          </ul>

          

<p className='sidebar-menu-title mt-4'>Plans</p>
 <ul className='list-unstyled ps-0'>
            <li className='sidebar-item' onClick={() => setPlanOpen(!plansOpen)}>
              <FaRegFileArchive size={22} />
              <span className='sidebar-text'>Manage Plan</span>
            </li>

            {plansOpen && <ul className='sidebar-submenu'>
                <li className={`sidebar-item ${location.pathname === '/admin/subscription-plan' ? 'active' : ''}`} onClick={() => {
              navigate('/admin/subscription-plan');
              setCollapsed(false);
              setServicesOpen(false);
            }}>

                     {!collapsed && <FaFilePen size={22} />}
                                    <span className='sidebar-text'>Subscriptions Plan</span>
                 
                </li>

                  <li className={`sidebar-item ${location.pathname === '/admin/subscription-history' ? 'active' : ''}`} style={{
              position: "relative"
            }} onClick={() => {
              navigate('/admin/subscription-history');
              setCollapsed(false);
              setServicesOpen(false);
              setPlanNotification(false);
            }}>

                     {!collapsed && <LiaPagerSolid size={22} />}
                                    <span className='sidebar-text'>Subscriptions History</span>
                                    
                                    {planNotification && <span style={{
                width: "8px",
                height: "8px",
                background: "red",
                borderRadius: "50%",
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)"
              }} />}
                 
                </li>

                   <li className={`sidebar-item ${location.pathname === '/admin/subscription-report' ? 'active' : ''}`} onClick={() => {
              navigate('/admin/subscription-report');
              setCollapsed(false);
              setServicesOpen(false);
            }}>

                     {!collapsed && <LiaPagerSolid size={22} />}
                                    <span className='sidebar-text'>Subscriptions Report</span>

                 
                </li>

                    <li className={`sidebar-item ${location.pathname === '/admin/custom-plan' ? 'active' : ''}`} onClick={() => {
              navigate('/admin/custom-plan');
              setCollapsed(false);
              setServicesOpen(false);
            }}>

                     {!collapsed && <LuFilePen size={22} />}
                                    <span className='sidebar-text'>Custom Plan</span>
                 
                </li>
               
               
              </ul>}
          </ul>


              <p className='sidebar-menu-title mt-4'>Staff </p>
               <ul className='list-unstyled ps-0'>
            <li className='sidebar-item' onClick={() => setStaffOpen(!staffOpen)}>
              <GrUserManager size={22} />
              <span className='sidebar-text'>Staff</span>
            </li>

            {staffOpen && <ul className='sidebar-submenu'>
                <li className={`sidebar-item ${location.pathname === '/admin/staff' ? 'active' : ''}`} onClick={() => {
              navigate('/admin/staff');
              setCollapsed(false);
              setStaffOpen(false);
            }}>

                     {!collapsed && <FaAddressBook size={22} />}
                                    <span className='sidebar-text'>Manage Staff</span>
                 
                </li>

                    <li className={`sidebar-item ${location.pathname === '/admin/daily-attendence' ? 'active' : ''}`} onClick={() => {
              navigate('/admin/daily-attendence');
              setCollapsed(false);
              setStaffOpen(false);
            }}>

                     {!collapsed && <BsPersonBadge size={22} />}
                                    <span className='sidebar-text'>Daily Attendence </span>
                 
                </li>


                    <li className={`sidebar-item ${location.pathname === '/admin/monthly-attendence' ? 'active' : ''}`} onClick={() => {
              navigate('/admin/monthly-attendence');
              setCollapsed(false);
              setStaffOpen(false);
            }}>

                     {!collapsed && <TbReportSearch size={22} />}
                                    <span className='sidebar-text'>Monthly Attendence </span>
                 
                </li>
             

                     <li className={`sidebar-item ${location.pathname === '/admin/payroll' ? 'active' : ''}`} onClick={() => {
              navigate('/admin/payroll');
              setCollapsed(false);
              setStaffOpen(false);
            }}>

                     {!collapsed && <MdFindInPage size={22} />}
                                    <span className='sidebar-text'>Payroll </span>
                 
                </li>
               
                      <li className={`sidebar-item ${location.pathname === '/admin/staff-withdrawal' ? 'active' : ''}`} onClick={() => {
              navigate('/admin/staff-withdrawal');
              setCollapsed(false);
              setStaffOpen(false);
            }}>

                     {!collapsed && <BsWalletFill size={22} />}
                                    <span className='sidebar-text'>Withdrawal</span>
                 
                </li>
                
               
              </ul>}
          </ul>




         <p className='sidebar-menu-title mt-4'>Task </p>   
         <ul className='list-unstyled ps-0'>
            <li className='sidebar-item' onClick={() => setTaskOpen(!taskOpen)}>
              <GrTask size={22} />
              <span className='sidebar-text'> Task</span>
            </li>
         </ul>

           {taskOpen && <ul className='sidebar-submenu'>
               <li className={`sidebar-item ${location.pathname === '/admin/task' ? 'active' : ''}`} onClick={() => {
            navigate('/admin/task');
            setCollapsed(false);
            setDashboardOpen(false);
          }}> {!collapsed && <VscTasklist size={22} />}
                  <span className='sidebar-text'>Task List</span>
                  
                </li>

                 <li className={`sidebar-item ${location.pathname === '/admin/task-report' ? 'active' : ''}`} onClick={() => {
            navigate('/admin/task-report');
            setCollapsed(false);
            setDashboardOpen(false);
          }}> {!collapsed && <TbReportSearch size={22} />}
                  <span className='sidebar-text'>Task Report</span>
                  
                </li>
            </ul>}


            


   <p className='sidebar-menu-title mt-4'>Quick Service </p>
     <ul className='list-unstyled ps-0'>
 <li className='sidebar-item' onClick={() => setQuickOpen(!quickOpen)}>
              <SiQuicktime size={22} />
              <span className='sidebar-text'>Quick Services</span>
            </li>


             {quickOpen && <ul className='sidebar-submenu'>

                

                 <li className={`sidebar-item ${location.pathname === '/admin/quick-history' ? 'active' : ''}`} style={{
              position: "relative"
            }} onClick={() => {
              navigate('/admin/quick-history');
              setCollapsed(false);
              setDashboardOpen(false);
              setQuickNotification(false);
            }}> {!collapsed && <MdOutlineQuickreply size={22} />}
                  <span className='sidebar-text'>Quick Service History</span>

                   {quickNotification && <span style={{
                width: "8px",
                height: "8px",
                background: "red",
                borderRadius: "50%",
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)"
              }} />}
                  
                </li>

                       <li className={`sidebar-item ${location.pathname === '/admin/quick-pending' ? 'active' : ''}`} onClick={() => {
              navigate('/admin/quick-pending');
              setCollapsed(false);
              setDashboardOpen(false);
            }}> {!collapsed && <HiDocumentCurrencyRupee size={22} />}
                  <span className='sidebar-text'>Quick Pending Transaction</span>
                  
                </li>

                 

                   <li className={`sidebar-item ${location.pathname === '/admin/settlement-report' ? 'active' : ''}`} onClick={() => {
              navigate('/admin/settlement-report');
              setCollapsed(false);
              setDashboardOpen(false);
            }}> {!collapsed && <TbReportSearch size={22} />}
                  <span className='sidebar-text'>Settlement Report</span>
                  
                </li>

                  <li className={`sidebar-item ${location.pathname === '/admin/sale-report' ? 'active' : ''}`} onClick={() => {
              navigate('/admin/sale-report');
              setCollapsed(false);
              setDashboardOpen(false);
            }}> {!collapsed && <TbReportMoney size={22} />}
                  <span className='sidebar-text'>Sale Report</span>
                  
                </li>

                </ul>}

     </ul>



       <p className='sidebar-menu-title mt-4'>Setting </p>
               <ul className='list-unstyled ps-0'>
            <li className='sidebar-item' onClick={() => setSettingOpen(!settingOpen)}>
              <MdOutlineSettingsApplications size={22} />
              <span className='sidebar-text'>Setting</span>
            </li>

            {settingOpen && <ul className='sidebar-submenu'>
                <li className={`sidebar-item ${location.pathname === '/admin/setting' ? 'active' : ''}`} onClick={() => {
              navigate('/admin/setting');
              setCollapsed(false);
              setDashboardOpen(false);
            }}> {!collapsed && <IoSettingsSharp size={22} />}
                  <span className='sidebar-text'>General Settings</span>
                  
                </li>
                <li onClick={() => {
              navigate('/admin/banner');
              setCollapsed(false);
              setDashboardOpen(false);
            }} className='sidebar-item'>
                   {!collapsed && <MdAddPhotoAlternate size={22} />}
                  <span className='sidebar-text'>Banner</span>
                </li>

                <li onClick={() => {
              navigate('/admin/pincode-master');
              setCollapsed(false);
              setDashboardOpen(false);
            }} className='sidebar-item'>
                   {!collapsed && <HiLocationMarker size={22} />}
                                    <span className='sidebar-text'>Pincode Setup</span>

                </li>
                 
                   <li onClick={() => {
              navigate('/admin/site-enquiry');
              setCollapsed(false);
              setDashboardOpen(false);
            }} className='sidebar-item'>
                   {!collapsed && <MdManageSearch size={22} />}
                                    <span className='sidebar-text'>Site Enquiry</span>

                </li>

                 <li onClick={() => {
              navigate('/admin/time-slot');
              setCollapsed(false);
              setDashboardOpen(false);
            }} className='sidebar-item'>
                   {!collapsed && <MdAccessTime size={22} />}
                                    <span className='sidebar-text'>Set Time Slot</span>

                </li>
                
               
               
              </ul>}
          </ul>


          {/* Logout */}
          <ul className='list-unstyled ps-0 mt-4'>
            <li className='sidebar-item' onClick={() => setShowLogout(true)}>
              <IoPower size={22} />
              <span className='sidebar-text'>Log Out</span>
            </li>
          </ul>
        </div>

        <span className="sidebar-btn py-3" onClick={toggleSidebar}>
          {collapsed ? <FaAngleLeft size={22} /> : <FaAngleRight size={22} />}
        </span>
      </div>


 {showLogout && <section className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" style={{
      background: "rgba(0,0,0,0.75)",
      zIndex: 1050,
      backdropFilter: "blur(6px)"
    }} onClick={() => setShowLogout(false)}>
    <div className="bg-dark text-white rounded-4 shadow-lg p-4 p-md-5 text-center animate__animated animate__zoomIn" style={{
        width: "100%",
        maxWidth: "420px",
        border: "1px solid rgba(255,255,255,0.08)"
      }} onClick={e => e.stopPropagation()}>
      {/* Icon */}
<div className="mb-3">
  <div className="mx-auto d-flex align-items-center justify-content-center rounded-circle" style={{
            width: "65px",
            height: "65px",
            background: "rgba(220,53,69,0.15)"
          }}>
    <BiLogOut size={30} color="#dc3545" />
  </div>
</div>


      {/* Message */}
      <p className="text-secondary small mb-4">
        Are you sure you want to logout? 
      </p>

      {/* Buttons */}
      <div className="d-flex gap-2 justify-content-center">
        <button className="btn btn-outline-light px-4 py-2 rounded-pill" onClick={() => setShowLogout(false)}>
          Cancel
        </button>

        <button className="btn btn-danger px-4 py-2 rounded-pill shadow-sm" onClick={handleLogout}>
          Yes, Logout
        </button>
      </div>
    </div>
  </section>}
    </>;
};
export default AdminSidebar;
